import React from 'react';
import Select from 'react-select';
import Adal from '../../adal/adal-request';
import {REST_URL} from '../../constants';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

import classNames from 'classnames';

class UserSelect extends React.Component {

  constructor(props) {
    super(props);
    const userId = props.userId ? props.userId : -1;
    this.state = {userId : userId};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      console.log('UserSelect userId updated:', this.props.userId);
    }
  }

  lazyLoadUsers (input, callback){
      var { includeManager } = this.props;
      includeManager = includeManager ? includeManager : false;


      const {intl} = this.props;
      const t = (message, data = {}) => {
          return intl.formatMessage({id : message}, data);
      };
      
      const compact = this.props.compact;    
      if(typeof input === 'object'){
        var onSelectUser = this.props.onSelectUser;
        this.setState({
          userId : input ?  input.Id : -1
        });
        if(onSelectUser){
          if(includeManager){
            Adal.adalRequest({url: REST_URL + 'users/parent/' + input.Id }).then((payload)=>{
              input.ManagerId = payload.Id;
              input.Manager = payload;
              onSelectUser(input);
            }, () => {
              onSelectUser(input);
            });
          }else{
            onSelectUser(input);
          }
        }
        return;
      }
    
     
      Adal.adalRequest({url: REST_URL + 'users/search?text=' + input }).then((payload)=>{
        let users = payload.map((usr, idx) => {
           var label = usr.DisplayName;
           var innerLabel = "";
           if(usr.Account){
              innerLabel += t('Account') + ' :' + usr.Account;
           }
           /*
           if(usr.SAPNumber){
              if(innerLabel.length > 0) innerLabel += ",";
              innerLabel += t('SAP Number') + ' :' + usr.SAPNumber;
           }*/
           if(innerLabel.length > 0){
              innerLabel = '(' + innerLabel + ')';
           }
           return Object.assign(usr, {label : label + innerLabel, value : usr.Id, className : compact ? 'compact-select-item' : 'bold-select-item'});
         }); 
         callback(null, {
            options: users,
            complete: false
         });
      });
  }

  render() {
    console.log('UserSelect render with userId:', this.props.userId);
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    const compact = this.props.compact;
    var className = this.props.className ? this.props.className : '';
    const userId = this.props.userId ? this.props.userId : -1;
    const user = this.props.user;
    // Use full user object if available (for restoring selections), otherwise use userId
    const selectValue = user ? user : userId;
    const defaultText = this.props.defaultText;
    const placeholder =  defaultText || (t('Select') + ' ...');
    let clearOnBlur = false;
    if(this.props.clearOnBlur) {
      clearOnBlur = true;
    }
    const {disabled} = this.props;

    var classes = {
       'compact' : compact,
       'hasDefaultText' : defaultText
    };
    className = classNames(classes) + ' ' + className;
    return (
      <Select.Async ignoreAccents={false} cache={false} disabled={disabled || false} placeholder={placeholder} value={selectValue} className={className}
                      loadOptions={this.lazyLoadUsers.bind(this)} onChange={this.lazyLoadUsers.bind(this)} onSelectResetsInput={false} onBlurResetsInput={clearOnBlur}
      />
    );
  }
}

UserSelect.displayName = 'UserSelect';
UserSelect.propTypes = {
  onSelectUser: React.PropTypes.func.isRequired
};
UserSelect.defaultProps = {};

export default injectIntl(UserSelect);




// WEBPACK FOOTER //
// ./components/Shared/UserSelect.js